<template>
  <div class="bg-documentGray" :class="isScroll ? 'h-full': ''">
    <display-file v-if="isFilePriview2" v-bind:file="filePriviewData2" @closePopup="closePopup"></display-file>
    <main v-if="detail" class="main-wrapper flex-grow-1 with-footer">
      <div class="d-flex align-items-center fix-header-title bg-white">
        <div class="t-headline13 t-color-headlineBlack pda-14 t-center  flex-grow-1 ">
          <div class="font-m">{{ boardName }}</div>
        </div>
        <div class="right-button">
          <div v-show="(detail && (!detail.owner || (selectedChild && selectedChild.modify === true) || (selectedChild && selectedChild.remove === true)))"
              class="pdl-16 mgr-16 mdc-menu-anchor menu-container cursor-pointer more-btn-parent-div position-relative header-toggle">
            <i class="material-icons mdc-icon-button t-headline6 dkk1 js--dropdown-toggle" tabindex="0"
               @click="handleModal(detail.id)" @keypress="handleModal(detail.id)">more_horiz</i>
            <!-- 게시글 부분 -->
            <UserDetailActionModal
              v-if="isOpenModal && detail.id === selectedId"
              :type="'BOARD'"
              :data="detail" 
              :selectedChild="selectedChild"
              @report="askForReport" 
              @block="handleBlock" 
              @edit="askForModify(detail.id)" 
              @delete="askForDelete"
              :className="'action-modal'"
            />
          </div>
        </div>
      </div>
      <div class="divider"></div>
      <div v-if="detail" :style="form.images.length > 0 ? 'padding-bottom: 182px':'padding-bottom: 42px'"
           class="scroll-y">
        <div class="shadow2 fix-header-title-content bg-white">
          <div :class="(comments && comments.length > 0) ? '': 'pdb-40'"
               class="container container--narrow pdt-24 remove-padding">
            <div class="d-flex">
              <UserImgProfile :allData="detail" :data="detail.auditor.register" :className="'mgr-0'" />
              
              <div class="flex-grow-1 pdl-16">
                <div class="d-flex justify-content-between">
                  <div class="t-body1 mgb-1 font-r mgb-4" :class="{'t-color-bodyGrayB': detail.isBlocked}">
                    {{
                      detail.auditor ? $t('3437', {
                        first: detail.auditor.register.name.first,
                        last: detail.auditor.register.name.last
                      }) : ''
                    }}
                  </div>
                  <div class="t-body3 font-r t-color-bodyGrayA">
                    {{ $moment(detail.auditor ? detail.auditor.register.time : '').format("L") }}
                  </div>
                </div>
                <div v-if="detail.auditor.register.storeName" class="d-flex user-list-info font-r">
                  <div class="t-body3 t-color-bodyGrayA pdr-8 mgr-8" :class="{'t-color-bodyGrayB': detail.isBlocked}">
                    {{ detail.auditor ? detail.auditor.register.storeName : '' }}
                  </div>
                  <div class="t-body3 t-color-bodyGrayA pdr-8 mgr-8" :class="{'t-color-bodyGrayB': detail.isBlocked}">
                    {{ detail.auditor ? detail.auditor.register.responsibilityName : '' }}
                  </div>

                </div>
                <div v-else :class="{'t-color-bodyGrayB': detail.isBlocked}" class="t-body3 t-color-bodyGrayA pdr-8 mgr-8">{{ detail.auditor.register.storeName ? detail.auditor.register.storeName : brandName }}</div>
              </div>
            </div>
            <div class="mgt-20" :class="{'t-color-bodyGrayB pdb-20': detail.isBlocked}">
              {{ detail.isBlocked ? $t("3814") : detail.contents.subject }}
              <span v-if="!detail.isBlocked" class="t-preline"
                    v-html="detail.contents && detail.contents.body">
              </span>
<!--              <div v-else class="t-body6 font-r t-color-bodyGrayA mgt-16 mgb-16 l-spacing45 t-line-h-25 t-prewrap">{{ listFilter(detail ? detail.contents.body : '') }}</div>-->
            </div>
            <div v-if="!detail.isBlocked && detail.tags.length" class="d-flex mgt-8 mgb-24">
              <div
                  v-for="(tag, i) in detail.tags" :key="i"
                  class="pdl-4 pdr-4 b-radius2 mgr-4 t-body3 font-r t-color-contentBlue bg-contentBlueInactive min-h-22 t-center">
                #{{ tag.name }}
              </div>
            </div>

            <div class="" v-if="!detail.isBlocked">
              <a v-for="(img, i) in detail.contents.files" :key="i"
                 href="javascript:void(0)" tabindex="0" class="noClick">
                <img v-if="getType(img.contentType) === 'image'" :alt="img.originalName" :src="img.resourceUri"
                     class="mgt-16 b-radius4"/>
                  <VideoComponent
                      v-else
                      :record="img"
                      :fullSizeVideo="true"
                      :videoSize="'large'"
                      class="mgt-16">
                  </VideoComponent>
              </a>
            </div>

            <div class="d-flex justify-content-between align-items-center pdt-20 pdb-20" v-if="!detail.isBlocked">
              <div class="d-flex flex-grow-1">
                <div class="t-color-bodyGrayB t-helper font-r pdr-24">{{ $t("1437", {str: detail.likesCount}) }}</div>
                <div class="t-color-bodyGrayB t-helper font-r pdr-24">{{ $t("1438", {str: detail.commentCount}) }}</div>
              </div>
              <div class="t-color-bodyGrayB t-helper font-r ">{{ $t("1439", {str: detail.viewCount}) }}</div>
            </div>
            <div class="divider" v-if="!detail.isBlocked"></div>
            <div class="d-flex justify-content-evenly pdt-13 pdb-13" v-if="!detail.isBlocked">
              <button class="mdc-button" tabindex="0" @click="patchLikeState(detail.id, detail.like)" @keypress="patchLikeState(detail.id, detail.like)">
                <span class="mdc-button__ripple"></span>
                <i :class="detail.like ? 't-color-red' : 't-color-iconInactive'"
                   aria-hidden="true"
                   class="material-icons mdc-button__icon font-20 w-20 h-20">
                  {{ detail.like ? 'favorite' : 'favorite_border' }}
                </i>
                <span class="mdc-button__label t-body3 font-r t-color-iconInactive">{{ $t("1440") }}</span>
              </button>
              <button class="mdc-button">
                <span class="mdc-button__ripple"></span>
                <i aria-hidden="true" class="material-icons mdc-button__icon t-color-iconInactive font-20 w-20 h-20">
                  chat_border
                </i>
                <span class="mdc-button__label t-body3 font-r t-color-iconInactive">{{ $t("1441") }}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="bg-documentGray mgt-2 pdb-50">
          <div class="container container--narrow pdt-16">
            <div v-for="comment in comments" :key="comment.id" class="d-flex mgb-16">
              <UserImgProfile v-if="comment.auditor" :allData="comment" :data="comment.auditor.register" :className="'mgr-0 mgt-16'" />

              <div class="d-flex flex-row-reverse w-full">
                <div v-show="comment.status.value === commentStatusConstants.post && selectedChild && (selectedChild.modify === true || selectedChild.remove === true)" class="pdl-16 more-btn-parent-div mdc-menu-anchor menu-container cursor-pointer header-toggle"
                     style="margin-right:-18px">
                  <i class="material-icons mdc-icon-button dkk2 t-headline6 js--dropdown-toggle t-color-iconInactive"
                     tabindex="0"
                     @click="handleModal(comment.id)" @keypress="handleModal(comment.id)">more_horiz</i>
                  <!-- 댓글 부분 -->
                  <UserDetailActionModal
                    v-if="isOpenModal && comment.id === selectedId"
                    :type="'COMMENT'"
                    :data="comment" 
                    :selectedChild="selectedChild"
                    @report="reportComment" 
                    @block="handleBlock" 
                    @edit="editCommentSet" 
                    @delete="deleteComment"  
                    :className="'action-modal'"
                  />
                </div>
                <div class="flex-grow-1  mgt-16">
                  <div class="d-flex justify-content-between pdl-16">
                    <div class="t-body1 mgb-1 font-r mgb-4" :class="{'t-color-bodyGrayB': comment.isBlocked}">{{ comment.auditor && comment.auditor.register &&
                        comment.auditor.register.name ? $t('3437', {
                          first: comment.auditor.register.name.first,
                          last: comment.auditor.register.name.last
                        }) : ''
                      }}
                    </div>
                  </div>
                  <div v-if="comment.status.value === commentStatusConstants.post">
                    <div v-if="comment.auditor && comment.auditor.register && comment.auditor.register.storeName" class="d-flex user-list-info font-r pdl-16 mgb-4">
                      <div class="t-body3 t-color-bodyGrayA pdr-8 mgr-8" :class="{'t-color-bodyGrayB': comment.isBlocked}">{{ comment.auditor.register.storeName }}
                      </div>
                      <div class="t-body3 t-color-bodyGrayA pdr-8 mgr-8" :class="{'t-color-bodyGrayB': comment.isBlocked}">
                        {{ comment.auditor && comment.auditor.register && comment.auditor.register.responsibilityName }}
                      </div>
                    </div>
                    <div v-else class="user-list-info font-r pdl-16 mgb-4 t-body3 t-color-bodyGrayA pdr-8 mgr-8" :class="{'t-color-bodyGrayB': comment.isBlocked}">
                      {{ comment.auditor && comment.auditor.register && comment.auditor.register.storeName ? comment.auditor.register.storeName : brandName }}
                    </div>
                  </div>

                  <div v-show="comment.status.value === commentStatusConstants.post" class="t-body3 font-r t-color-bodyGrayA  pdl-16 mgt-4" :class="{'t-color-bodyGrayB': comment.isBlocked}">
                    {{ $moment(comment.auditor && comment.auditor.register && comment.auditor.register.time).format("L") }}
                  </div>

                  <div v-if="comment.status.value === commentStatusConstants.removed" class="t-body3 font-r t-color-bodyGrayA mgt-16 l-spacing45 t-line-h-25 pdl-16 pdb-10">
                    <p class="date">{{ $t('3749') }}</p>
                  </div>
                  <div v-else-if="comment.status.value === commentStatusConstants.hided" class="t-body3 font-r t-color-bodyGrayA mgt-16 l-spacing45 t-line-h-25 pdl-16 pdb-10">
                    <p class="date">{{ $t('3750') }}</p>
                  </div>
                  <div v-else-if="comment.status.value === commentStatusConstants.post"
                       class="t-body3 font-r t-color-bodyGrayA mgt-16 l-spacing45 t-line-h-25 pdl-16 pdb-10 t-preline"
                       :class="{'t-color-bodyGrayB': comment.isBlocked}"
                       v-html="comment.isBlocked ? $t('3814') : comment.contents">
                  </div>

                  <show-slider v-if="!comment.isBlocked" :="false" :imageArray="comment" @fileDisplay="fileDisply"></show-slider>
                  <div class="d-flex  mgt-8 pdl-8" v-if="!comment.isBlocked && comment.status.value === commentStatusConstants.post">
                    <button class="mdc-button" tabindex="0" @click="likeComment(comment.id, comment.likes)">
                      <span class="mdc-button__ripple"></span>
                      <i :class="comment.likes ? 't-color-red' : 't-color-iconInactive'"
                         aria-hidden="true"
                         class="material-icons mdc-button__icon font-16-6">{{
                          comment.likes ? 'favorite' : 'favorite_border'
                        }}</i>
                      <span class="mdc-button__label t-body3 font-r t-color-iconInactive">{{
                          $t("1443", {str: comment.likesCount})
                        }}</span>
                    </button>
                    <button class="mdc-button" tabindex="0"
                            @click="toggleReply(comment.id,comment.auditor.register.name.fullName)" >
                      <span class="mdc-button__ripple"></span>
                      <i aria-hidden="true" class="material-icons mdc-button__icon t-color-iconInactive font-16-6">
                        chat_border
                      </i>
                      <span class="mdc-button__label t-body3 font-r t-color-iconInactive">
											{{ $t('1444') }}
										</span>
                    </button>
                  </div>
                  <input id="replyCommentId" type="hidden"/>
                  <div :id="`commentInput_${comment.id}`" class="d-none">
                  </div>
                  <!-- reply section -->
                  <div v-for="reply in comment.children" :key="reply.id" class="d-flex mgb-16 reply-box mgl-16">
                    <UserImgProfile v-if="comment.auditor" :allData="reply" :data="reply.auditor.register" :className="'mgr-0 mgt-16'" size="s"  />

                    <div class="d-flex flex-row-reverse w-full">
                      <div v-show="reply.status.value === commentStatusConstants.post && selectedChild && ( selectedChild.modify === true || selectedChild.remove === true)"
                          class="pdl-16  more-btn-parent-div mdc-menu-anchor menu-container cursor-pointer header-toggle mgr--18">
                        <i class="material-icons mdc-icon-button dkk3 t-headline6 js--dropdown-toggle t-color-iconInactive"
                           tabindex="0"
                           @click="handleModal(reply.id)" @keypress="handleModal(reply.id)">more_horiz</i>
                       

                        <!-- 댓글 부분 -->
                        <UserDetailActionModal
                          v-if="isOpenModal && reply.id === selectedId"
                          :type="'REPLY'"
                          :data="reply" 
                          :parentData="comment"
                          :selectedChild="selectedChild"
                          @report="reportComment" 
                          @block="handleBlock" 
                          @edit="editReplySet" 
                          @delete="deleteComment"  
                          :className="'action-modal'"
                        />
                      </div>
                      <div class="flex-grow-1  mgt-16">
                        <div class="d-flex justify-content-between pdl-16">
                          <div class="t-body1 mgb-1 font-r mgb-4" :class="{'t-color-bodyGrayB': reply.isBlocked}">{{
                              reply.auditor.register.name ? $t('3437', {
                                first: reply.auditor.register.name.first,
                                last: reply.auditor.register.name.last
                              }) : ''
                            }}
                          </div>
                        </div>
                        <div v-if="reply.auditor.register.storeName" class="d-flex user-list-info font-r pdl-16">
                          <div class="t-body3 t-color-bodyGrayA pdr-8 mgr-8" :class="{'t-color-bodyGrayB': reply.isBlocked}">
                            {{ reply.auditor.register.storeName }}
                          </div>
                          <div class="t-body3 t-color-bodyGrayA pdr-8 mgr-8" :class="{'t-color-bodyGrayB': reply.isBlocked}">
                            {{ reply.auditor.register.responsibilityName }}
                          </div>
                        </div>
                        <div v-else class="pdl-16 t-body3 t-color-bodyGrayA pdr-8 mgr-8" :class="{'t-color-bodyGrayB': reply.isBlocked}">
                          {{ reply.auditor.register.storeName ? reply.auditor.register.storeName : brandName }}
                        </div>

                        <div v-show="reply.status.value === commentStatusConstants.post" class="t-body3 font-r t-color-bodyGrayA  pdl-16 mgt-4" :class="{'t-color-bodyGrayB': reply.isBlocked}">
                          {{ $moment(reply.auditor.register.time).format("L") }}
                        </div>
                        <div v-if="reply.status.value === commentStatusConstants.removed" class="t-body3 font-r t-color-bodyGrayA mgt-16 l-spacing45 t-line-h-25 pdl-16 pdb-10">
                          <p class="date">{{ $t('3749') }}</p>
                        </div>
                        <div v-else-if="reply.status.value === commentStatusConstants.hided" class="t-body3 font-r t-color-bodyGrayA mgt-16 l-spacing45 t-line-h-25 pdl-16 pdb-10">
                          <p class="date">{{ $t('3750') }}</p>
                        </div>
                        <div v-else-if="reply.status.value === commentStatusConstants.post"
                             class="t-body3 font-r t-color-bodyGrayA mgt-16 l-spacing45 t-line-h-25 pdl-16 pdb-10 t-preline" :class="{'t-color-bodyGrayB': reply.isBlocked}"
                             v-html="reply.isBlocked ? $t('3814') : reply.contents">
                        </div>
                        <show-slider v-if="!reply.isBlocked" :fileData="true" :imageArray="reply" @fileDisplay="fileDisply"></show-slider>
                        <div class="d-flex  mgt-8 pdl-8" v-if="!reply.isBlocked">
                          <button class="mdc-button" tabindex="0" @click="likeReply(reply.id, reply.likes, comment.id)" @keypress="likeReply(reply.id, reply.likes, comment.id)">
                            <span class="mdc-button__ripple"></span>
                            <i :class="reply.likes ? 't-color-red' : 't-color-iconInactive'"
                               aria-hidden="true"
                               class="material-icons mdc-button__icon font-16-6">{{
                                reply.likes ? 'favorite' : 'favorite_border'
                              }}</i>
                            <span class="mdc-button__label t-body3 font-r t-color-iconInactive">{{
                                $t("1443", {str: reply.likesCount})
                              }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end of reply section -->
                </div>
              </div>
            </div>
            <infinite-loading :identifier="infiniteId" spinner="spiral" @infinite="getComments">
              <div slot="no-more" class="t-color-white"></div>
              <div slot="no-results" class="t-color-white"></div>
            </infinite-loading>
          </div>
        </div>

      </div>
      <div class="setHeightBlank"></div>
      <div class="toggle-menu-scrim d-none" @click="menuActivate" @keypress="menuActivate"></div>
    </main>
    <div class="footer bg-white bottomStack " v-if="!detail.isBlocked">
      <div class="divider"></div>

      <div v-if="selectedChild && selectedChild.register === true" class="container container--narrow pdb-0">
        <div class="d-flex align-items-center justify-content-between pdt-13 pdb-14">
          <div class="d-flex flex-grow-1 position-relative">
            <div v-if="userName" class="t-body3 t-color-linkBlue font-r bg-linkBg mention-text-area mgr-8 position-absolute">
              @{{ userName }}<span class="cursor-pointer t-color-iconInactive pdl-8 pdr-4 mgr-8" tabindex="0"
                                   @click="toggleReply" @keypress="toggleReply">x</span></div>
            <textarea
                id="comment_textarea"
                v-model="form.contents"
                :class="{'commentInvaliderror': commentValid}"
                :placeholder="$t('1445')"
                class="mdc-text-field__input t-body6 font-r l-spacing42 t-color-headlineBlack t-line-h-25 t-justify"
                maxlength="400"
                rows="1"
                tabindex="0"
                @click="setActive"
                @keypress="setActive"
                @keyup="resizeIt($event.target.value)"
            ></textarea>
          </div>
        </div>
        <div v-if="form.images.length > 0" class="d-flex scroll-x social-learning-attached-preview-video">
          <div v-for="(img, i) in form.images" :key="i"
               class="attached-image-preview-126 mgt-16 mgr-24 position-relative">
            <img v-if="getType(img.contentType) === 'image' " :alt="img.originalName" :src="img.resourceUri"/>
              <VideoComponent
                  v-else
                  :record="img"
                  :videoSize="'small'"
                  :fullSizeVideo="false">
              </VideoComponent>
            <span class="remove-img remove-image-new position-absolute t-color-white" tabindex="0"
                  @click="form.images.splice(i, 1)" @keypress="form.images.splice(i, 1)">
              <i class="material-icons t-body1">close</i>
            </span>
          </div>
        </div>
        <photo-album :form="form" class="" @removeImage="removeImage" @toggleDocument="toggleDocument"
                     @uploadFile="uploadFile">
          <button
              slot="submitButton"
              :class="(form.contents !== null && !isContentsEmpty) || !isFormImagesEmpty ? 'sendMessageBtnActive' : 'sendMessageBtn'"
              :disabled="isContentsEmpty && isFormImagesEmpty"
              class="mdc-icon-button t-color-white align-items-center justify-content-between mgr--12" tabindex="0"
              @click.prevent="submitComment" @keypress.prevent="submitComment">
            <i class="material-icons min-w-24 min-h-24">arrow_upward</i></button>
        </photo-album>
      </div>
    </div>
    <div v-if="isOpenModal" @click="closeModal" @keypress="closeModal" class="modal-background" />
  </div>
</template>

<script>
import {MDCMenu} from '@material/menu';
import {MDCRipple} from "@material/ripple";

import socialApi from "@/api/socialApi.js";
import InfiniteLoading from "vue-infinite-loading";

import {mapState, mapActions} from "vuex";
import DisplayFile from "./DisplayFile";
import ShowSlider from "../board/ShowSlider";
import {fileMixin} from "@/mixins/file";
import snackMessage from "@/plugins/snackMessage";
import {commentStatusConstants} from "@/utils/enum/CommentStatusConstants";
import { VueEditor } from "vue2-editor";
import VideoComponent from "@/components/common/VideoComponent.vue";
import {userMixin} from "@/mixins/user";
import UserDetailActionModal from '../common/modal/UserDetailActionModal.vue';

export default {
  components: {
    InfiniteLoading,
    VueEditor,
    DisplayFile,
    ShowSlider,
    VideoComponent,
    'photo-album': () => import('@/components/common/PhotoAlbum'),
    UserDetailActionModal,
    UserImgProfile: () => import("@/components/common/checkUser/UserImgProfile.vue"),
  },

  mixins: [fileMixin, userMixin],

  beforeCreate() {
    this.windowv = window;
  },

  computed: {
    isFormImagesEmpty() {
      return this.form.images.length === 0;
    },

    isContentsEmpty() {
      return this.form.contents === null || /^\s*$/.test(this.form.contents);
    }
  },

  mounted() {
    this.setMaterialUi();
    if ($(document).height() < $(window).height()) {
      this.isScroll = true;
    }
  },

  updated() {
    if (document.documentElement.scrollHeight < screen.availHeight) {
      var el = document.querySelector(".remove-padding");
      el.classList.remove('pdb-40');
    }
  },

  beforeMount() {
    this.boardId = this.$route.params.board;
    this.boardName = this.$route.query.boardName;
    if (this.boardName) {
      this.boardName = this.boardName;
    } else {
      this.boardName = this.$t("1427");
    }

    socialApi
        .boardAuth(this.boardId)
        .then((response) => {
          this.boardData = response.data.data;

          socialApi
              .fetchMember()
              .then((response) => {
                this.mamberData = response.data.data;
                let myId = this.mamberData.responsibilityId;

                if (this.boardData.authType.value === 'STORE') {
                  this.selectedChild = this.boardData.authPermission[0];
                } else {
                  this.selectedChild = this.boardData.authPermission.find(child => child.partId == myId);
                }
              })
              .catch((err) => {
                $state.error();
              });
        })
        .catch((err) => {
          $state.error();
        });
    this.setDetail();
  },
  data() {
    return {
      menuBar: null,
      coomentActiveButton: false,
      commentValid: false,
      detail: null,
      comments: [],
      isFilePriview2: false,
      filePriviewData2: null,
      form: {
        contents: null,
        images: [],
      },
      replyImg: [],
      isComment: true,
      isNoData: false,
      currentPage: 1,
      totalPages: 1,
      infiniteId: +new Date(),
      isError: false,
      selectedChild: "",
      mamberData: [],
      windowv: {},
      boardName: "",
      commentEdit: false,
      commentEditId: null,
      replyEdit: false,
      replyEditId: null,
      boardId: null,
      boardData: null,
      b: true,
      userName: '',
      evtReply: {},
      commentBottom: true,
      bgColorOfName: localStorage.getItem('bgColors'),
      commentStatusConstants: commentStatusConstants,
	    isScroll: false,
      brandName: localStorage.getItem("brandName"),
      isOpenModal: false,
      selectedId: null,
    };
  },

  methods: {
    ...mapActions("social", ["SET_LIKE", "SET_VIEW"]),

    menuActivate() {
      const toggleBackground = document.querySelector('.toggle-menu-scrim');
      toggleBackground.classList.add('d-none');
      let openedMenubar = document.querySelector(".mdc-menu-surface--open");
      if (openedMenubar) {
        openedMenubar.classList.remove("mdc-menu-surface--open");
      }
    },

    firstCharOfMemberName(name) {
      if(!name) {
        return;
      }
      if (name.first) {
        let fullName = this.$t('3437', {first: name.first, last: name.last});
        return fullName.charAt(0);
      } else {
        let fullName = name.fullName;
        return fullName.charAt(1);
      }
    },

    setMaterialUi() {
      const buttonRipple = [].map.call(
          document.querySelectorAll(".mdc-button"),
          function (el) {
            let button = new MDCRipple.attachTo(el);
            return button;
          }
      );
    },

    closePopup() {
      this.filePriviewData2 = null;
      this.isFilePriview2 = false;
    },

    getWHieght() {
      return $(window).width();
    },

    resizeIt(str) {
      var elmnt = document.getElementById("comment_textarea");
      var newElement = document.querySelector('.setHeightBlank');
      elmnt.style.height = 0;
      var scHeight = elmnt.scrollHeight;
      elmnt.style.height = scHeight + "px";
      newElement.style.height = (scHeight - 24) + "px";
      if (document.querySelector('.mention-text-area')) {
        let replyedBy = document.querySelector('.mention-text-area').clientWidth;
        document.querySelector("#comment_textarea").style.textIndent = replyedBy + 8 + 'px'
        } else {
        document.querySelector("#comment_textarea").style.textIndent = '0px'
      }
    },

    setActive() {
      this.coomentActiveButton = true;
    },

    initData() {
      this.comments = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1;
    },

    resetVideo() {
      this.form.images = Array();
    },

    submitReply(originId) {
      if (!this.replyEdit) {
        socialApi
            .boardAuth(this.boardId)
            .then(response => {
              this.$hideLoading();
              this.boardData = response.data.data;
              if (this.boardData.userCommToDayAuth) {

                // call API to add reply
                socialApi
                    .postReply(this.boardId, this.detail.id, originId, {
                      contents: this.form.contents,
                      images: this.form.images,
                    })
                    .then((response) => {
                      this.$hideLoading();
                      this.resetCommentForm();

                      this.toggleReply(originId);
                      this.replyImg = [];
                      this.setDetail();
                      this.userName = '';

                      // add reply into parent
                      for (let c in this.comments) {
                        if (this.comments[c].id == originId) {
                          this.comments[c].children.push(response.data.data);
                        }
                      }
                    })
                    .catch((err) => {
                      this.$error({content: err.errMsg}).then(() => {
                        this.$hideLoading();
                      });
                    });
              } else {
                this.$hideLoading();
                snackMessage(this.$t("3064"))
              }
            })
            .catch(err => {
              $state.error();
            });
      } else {
        socialApi
            .editReply(this.boardId, this.detail.id, this.replyEditId, {
              contents: this.form.contents,
              images: this.replyImg,
            })
            .then((response) => {
              this.$hideLoading();
              if (response.status === 200) {
                this.resetCommentForm();
                this.getListComments();
                this.toggleReply(originId);
                this.setDetail();

                this.userName = '';
                this.replyImg = [];
                this.replyEdit = false;

                for (let c in this.comments) {
                  if (this.comments[c].id == originId) {
                    let replyIndex = this.comments[c].children.findIndex(arr => arr.id == this.replyEditId);
                    this.comments[c].children[replyIndex] = response.data.data;
                    this.replyEditId = null;
                  }
                }
              }
            })
            .catch((err) => {
              this.$error({content: err.errMsg}).then(() => {
              });
            });
      }
    },

    videoAudioSelected() {
      if (
          (!this.uploadTypeImg && this.form.contents.files.length)
      ) {
        this.$alert({
          // title: this.$t('72'),
          content: this.$t("1473"),
          accept: this.$t("1476")
        });
        return false;
      }
      return true;
    },

    /**
     * Open menu report, modify and delete
     * @param evt 이벤트
     */
    toggleMore(evt) {
      let field = evt.target.closest(".more-btn-parent-div").querySelector(".more_box");
      field.classList.add('z-200');

      const toggleBackground = document.querySelector('.toggle-menu-scrim');
      let openedMenubar = document.querySelector(".mdc-menu-surface--open");

      if (openedMenubar) {
        openedMenubar.classList.remove("mdc-menu-surface--open");
      }

      field.classList.toggle("mdc-menu-surface--open");
      field.classList.toggle('mdc-menu-surface--is-open-below');
      toggleBackground.classList.remove('d-none');
    },

    // 유저 차단
    async handleBlock(item, isBlocked) {
      try {
        await this.blockUser(item, isBlocked);
        this.setDetail();
        this.getListComments();
      } catch (error) {
        console.log("BOARD BLOCK ERROR : ", error);
      } finally {
        this.closeModal();
      }
    },

     // modal handle function
    handleModal(id) {
      console.log(id)
      this.isOpenModal = !this.isOpenModal;
      this.selectedId = id;
    },

    // modal close function
    closeModal() {
      this.isOpenModal = false;
      this.selectedId = null;
    },

    setDetail() {
      this.$showLoading();
      socialApi
          .socialDetails(this.$route.params.postId, this.boardId)
          .then((response) => {
            this.detail = response.data.data;

            this.SET_VIEW({
              id: this.detail.id,
              viewCount: this.detail.viewCount,
              commentCount: this.detail.commentCount,
            });

            this.$hideLoading();
          })
          .catch((err) => {
            this.$error({content: err.errMsg}).then(() => {
            });
          });
    },

    patchLikeState(id, status) {
      this.$showLoading();

      let action = status
          ? socialApi.patchPostLike(this.boardId, id)
          : socialApi.patchPostDislike(this.boardId, id);

      action
          .then((response) => {
            this.$hideLoading();
            this.detail.like = !status;
            this.detail.likesCount = !status
                ? this.detail.likesCount + 1
                : this.detail.likesCount - 1;
            this.SET_LIKE({
              id: id,
              likesCount: this.detail.likesCount,
              like: !status,
            });
          })
          .catch((err) => {
            this.$error({content: err.errMsg}).then(() => {
            });
          });
    },

    deletePost() {
      this.$showLoading();

      socialApi
          .deletePost(this.boardId, this.detail.id)
          .then((response) => {
            this.$hideLoading();
            //this.$router.push({ name: "SocialLearningListing" });
            //this.$router.push('/socialLearning');
            this.$router.push(
                "/socialLearning/" + this.boardId + "?boardName=" + encodeURI(this.boardName)
            );
          })
          .catch((err) => {
            this.$error({content: err.errMsg}).then(() => {
            });
          });
    },

    askForReport(data) {
      if (!this.detail.report) {
        this.$router.push({
          name: "ReasonChoice",
          query: { ...this.$route.query, type: "BOARD" },
          params: { data }
        })
      } else {
        this.menuActivate();
        snackMessage(this.$t("3808"));
      }
    },

    askForModify(id) {
      this.$router.push({ 
        name: 'SLEdit', 
        params: { postId: id },
        query:{ board: this.boardId, boardName: this.boardName } 
      });
    },

    askForDelete() {
      this.$confirm({
        // title: this.$t('72'),   // 학습을 중단한 강의입니다.
        content: this.$t("1877"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
        accept: this.$t("1879"), // 확인
        cancel: this.$t("1878"), //'TODO-취소'
      }).then(() => {
        this.deletePost();
      }).catch(() => {
      });
    },

    reportPost() {
      // 2023-11-07 jaehyub.lee@emcast.com 임시 신고 처리 (이후 신고, 차단 공통화 작업 예정)
      // temp params
      const params = {
        reason: {
          value: "OTHERS",
          text: "",
          translate: "code.reason.others",
          customValues: {}
        },
        comment: "",
      }
      socialApi
          .reportPost(this.boardId, this.detail.id, params)
          .then((response) => {
            console.log("REPORT_POST_RES : ", response)
          })
          .catch((err) => {
            console.log("REPORT_POST_ERR : ", err);
          });
    },

    setParams() {
      let params = {
        page: this.currentPage,
        size: 10,
      };
      return params;
    },

    getListComments() {
      let params = {
        size: this.currentPage * 10,
      };
      socialApi.listComments(this.$route.params.postId, params).then((response) => {
        let responseData = response.data.data;
        this.comments = responseData.content;
      });
    },

    getComments($state) {
      let responseData = null;
      let params = this.setParams();
      if (this.totalPages >= this.currentPage) {
        socialApi.listComments(this.$route.params.postId, params).then((response) => {
          responseData = response.data.data;
          this.comments = this.comments.concat(responseData.content);

          if (responseData.content.length) {
            $state.loaded();
          } else {
            $state.complete();
          }

          this.currentPage++;
          this.totalPages = responseData.totalPages;

        }).catch((err) => {
        });
      } else {
        $state.complete()
      }
    },

    resetCommentForm() {
      this.form.contents = null;
      this.form = {
        contents: null,
        images: []
      };
      var elmnt = document.getElementById("comment_textarea");
      var newElement = document.querySelector('.setHeightBlank');
      elmnt.style.height = "unset";
      newElement.style.height = 0 + "px";
      document.querySelector("#comment_textarea").style.textIndent = '0px'
    },

    submitComment() {
      this.$stickyLoading();
      if (!this.detail) {
          this.$hideLoading();
          return this.commentValid = true;
      } else {
        if (this.b === true) {
          this.commentValid = false;
          if (this.commentEdit) {
            socialApi
                .commentEdit(this.detail.id, this.form, this.boardId, this.commentEditId)
                .then((resp) => {
                  this.$hideLoading();
                  if (resp.status === 200) {
                    this.getListComments();
                    this.resetCommentForm();
                    this.commentEdit = false;
                  } else {
                    console.log(resp.statusCode);
                  }
                })
                .catch((err) => {
                  this.$error({content: err.errMsg}).then(() => {
                    this.$hideLoading();
                  });
                  this.$hideLoading();
                });
          } else {
            socialApi
                .boardAuth(this.boardId)
                .then(response => {
                  this.boardData = response.data.data;
                  if (this.boardData.userCommToDayAuth) {
                    socialApi
                        .commentPost(this.detail.id, this.form, this.boardId)
                        .then((resp) => {
                          // reset comment form
                          this.resetCommentForm();

                          this.comments.push(resp.data.data);
                          this.detail.commentCount = this.detail.commentCount + 1;
                          this.SET_VIEW({
                            id: this.detail.id,
                            viewCount: this.detail.viewCount,
                            commentCount: this.detail.commentCount
                          });
                          this.$nextTick(() => {
                            window.scrollTo(0, document.body.scrollHeight);
                          })
                          this.$hideLoading();
                        })
                        .catch((err) => {
                          this.$error({content: err.errMsg}).then(() => {
                            this.$hideLoading();
                          });
                          this.$hideLoading();
                        });
                  } else {
                    this.$hideLoading();
                    snackMessage(this.$t('3064'));
                  }
                })
                .catch(err => {
                  this.$hideLoading();
                  $state.error();
                });
          }
        } else {
          let commentId = document.getElementById('replyCommentId').value;
          this.submitReply(commentId)
        }
      }
    },

    likeComment(id, status) {
      this.$showLoading();

      let action = status
          ? socialApi.dislikeComment(this.boardId, this.detail.id, id)
          : socialApi.likeComment(this.boardId, this.detail.id, id);

      action
          .then((response) => {
            this.$hideLoading();
            // search comment
            for (let c in this.comments) {
              if (this.comments[c].id == id) {
                this.comments[c].likes = !status;
                this.comments[c].likesCount = !status
                    ? this.comments[c].likesCount + 1
                    : this.comments[c].likesCount - 1;
                return;
              }
            }
          })
          .catch((err) => {
            this.$error({content: err.errMsg}).then(() => {
            });
          });
    },

    likeReply(replyId, replyStatus, id) {
      this.$showLoading();

      let action = replyStatus
          ? socialApi.dislikeComment(this.boardId, this.detail.id, replyId)
          : socialApi.likeComment(this.boardId, this.detail.id, replyId);

      action
          .then((response) => {
            this.$hideLoading();
            // search comment
            for (let c in this.comments) {
              if (this.comments[c].id == id) {
                // search for the reply in selected comment
                for (let r in this.comments[c].children) {
                  if (this.comments[c].children[r].id == replyId) {
                    this.comments[c].children[r].likes = !replyStatus;
                    this.comments[c].children[r].likesCount = !replyStatus
                        ? this.comments[c].children[r].likesCount + 1
                        : this.comments[c].children[r].likesCount - 1;
                  }
                }
                return;
              }
            }
          })
          .catch((err) => {
            this.$error({content: err.errMsg}).then(() => {
            });
          });
    },

    deleteComment(id, pid) {
      this.$confirm({
        content: this.$t("1877"), // '삭제하시겠습니까?'
        accept: this.$t("1879"), // '확인'
        cancel: this.$t("1878"), //'취소'
      }).then(() => {
        socialApi
            .deleteComment(this.boardId, this.detail.id, id)
            .then(() => {
              this.detail.commentCount = this.detail.commentCount - 1;
              this.getListComments();
              this.SET_VIEW({
                id: this.detail.id,
                viewCount: this.detail.viewCount,
                commentCount: this.detail.commentCount,
              });
            })
            .catch((err) => {
              this.$error({content: err.errMsg}).then(() => {
              });
            });
      });
      this.menuActivate();
    },

    reportComment(data) {
      this.menuActivate();
      if (data.report !== true) {
        this.$router.push({
          name: "ReasonChoice",
          query: { ...this.$route.query, type: "COMMENT" },
          params: { data: this.detail, commentData: data }
        })
      } else {
        snackMessage(this.$t("3738"))
      }
    },

    callReportComment(id, pid) {
      if (!this.detail.report) {
        this.$router.push({
          name: "ReasonChoice",
          query: { ...this.$route.query, type: "COMMENT" },
          params: { data }
        })
      } else {
        this.menuActivate();
        snackMessage(this.$t("3808"));
      }
    },

    toggleReply(commentId, userId) {
      this.commentBottom = false
      this.userName = userId
      this.b = !this.b;
      let comeId = document.getElementById('replyCommentId').value = commentId;
      if (comeId && this.b === false) {
        this.userName;
        this.$nextTick(() => {
          this.resizeIt()
        })
      } else {
        this.userName = '';
        document.querySelector("#comment_textarea").style.textIndent = '0px'
      }
      document.getElementById(`commentInput_${commentId}`).classList.toggle("d-none");
    },

    fileDisply(data) {
      this.filePriviewData2 = data;
      this.isFilePriview2 = true;
    },

    editCommentSet(comment, evt) {
      this.commentBottom = true;
      this.userName = '';
      this.replyEditId = '';
      this.replyEdit = false;
      this.form.contents = comment.contents;
      this.form.images = comment.images;
      this.commentEditId = comment.id;
      this.commentEdit = true;
      this.menuActivate();
    },

    editReplySet(reply, cid, evt, userId) {
      this.commentEditId = '';
      this.commentEdit = false;
      this.commentBottom = false;
      this.form.contents = reply.contents;
      this.form.images = reply.images;
      this.replyImg = reply.images;
      this.replyEditId = reply.id;
      this.replyEdit = true;
      this.toggleMore(evt)
      this.toggleReply(cid, userId)
    },

    goBackPreviousPage() {
      let likedSocialLearning = this.$route.query.likedSocial;
      if (likedSocialLearning === "true") {
        this.$router.push("/social-lesson");
      } else {
        this.$router.push(
            "/socialLearning/" +
            this.boardId +
            "?boardName=" +
            encodeURI(this.boardName)
        );
      }
    },
  },
};
</script>
<style scoped>
#comment_textarea:focus {
  color: var(--HeadlineBlack) !important;
}

#comment_textarea:focus + .sendMessageBtn i {
  background-color: var(--IconActive);
}

.mention-text-area {
  position: relative;
  white-space: nowrap;
  height: 20px;
  display: inline-block;
  /* margin-top: 12px; */
  padding: 0px 4px 6px;
  border-radius: 4px;
}

.video-player-box .video-js {
  width: 100% !important;
  height: 100% !important;
}

.more-btn-parent-div {
  position: absolute;
}

.mgr--18 {
  margin-right: -18px;
}

html[dir="rtl"] .mgr--18 {
  margin-left: -18px;
}

.community-detail .video-js {
  height: auto !important;
}

.community-detail .video-js video {
  position: relative !important;
}
@media (min-width: 1920px){
  .footer.bottomStack {
      width: calc(100% );

  }
}
 .attached-image-preview-126 img {
    width: 80px;
    height: 80px;
}
.noClick{
  text-decoration: none !important;
  cursor: default;
}

.action-modal {
  opacity: 1;
  min-width: 160px !important;
}

.modal-background{
  background: rgba(0, 0, 0, 0.01);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>

<style lang="css" scoped src="../../css/bootstrap.css">
</style>
